// Маппинг кодов ошибок бэкенда на понятные сообщения для пользователя
export const ERROR_MESSAGES = {
    // === AUTH ===
    'INVALID_CREDENTIALS': 'Неверный логин или пароль',
    'INVALID_TOKEN': 'Недействительный токен. Войдите заново',
    'TOKEN_EXPIRED': 'Сессия истекла. Войдите заново',
    'UNAUTHORIZED': 'Необходимо авторизоваться',
    'FORBIDDEN': 'Доступ запрещён',
    'USER_PASSWORD_TOO_SHORT_MIN_8': 'Пароль должен содержать минимум 8 символов',
    'PASSWORD_SHORT_MIN_8': 'Пароль должен содержать минимум 8 символов',
    'USER_INVALID_EMAIL': 'Некорректный email адрес',
    'USERNAME_IS_EMPTY': 'Имя пользователя не может быть пустым',
    'USER_PASSWORD_IS_EMPTY': 'Пароль не может быть пустым',
    'EMAIL_IS_EMPTY': 'Email не может быть пустым',
    'USERNAME_ALREADY_EXISTS': 'Это имя пользователя уже занято',
    'USER_EMAIL_ALREADY_EXISTS': 'Этот email уже зарегистрирован',
    'REFERRAL_CODE_NOT_FOUND': 'Реферальный код не найден. Проверьте ссылку или уберите код и зарегистрируйтесь без него',
    'USER_NOT_FOUND': 'Пользователь не найден',
    'VERIFY_CODE_INVALID': 'Код подтверждения не найден или недействителен',
    'VERIFY_CODE_EXPIRED': 'Код подтверждения истёк. Запросите новый',
    'VERIFY_CODE_ALREADY_USED': 'Код подтверждения уже использован',
    'EMAIL_NOT_CONFIRMED': 'Подтвердите почту, чтобы продолжить. Письмо со ссылкой отправлено при регистрации — его можно запросить повторно в настройках профиля',
    'USER_BANNED': 'Ваш аккаунт заблокирован администрацией. Если это ошибка — обратитесь в поддержку',
    'USER_IS_BANNED': 'Ваш аккаунт заблокирован администрацией. Если это ошибка — обратитесь в поддержку',
    'TOO_MANY_PASSWORD_ATTEMPTS': 'Слишком много попыток смены пароля. Попробуйте позже',
    'TOO_MANY_ACTIVATE_CODE_REQUESTS': 'Слишком много запросов кода подтверждения. Попробуйте позже',

    // === CHAT ===
    'CHAT_NOT_FOUND': 'Чат не найден',
    'MESSAGE_NOT_FOUND': 'Сообщение не найдено',
    'CHAT_MESSAGE_EMPTY': 'Сообщение не может быть пустым',
    'INVALID_PARTICIPANT': 'Вы не можете написать себе. Это ваше объявление',
    'RECIPIENT_DELETED': 'Пользователь удалил свой аккаунт',

    // === LISTING ===
    'LISTING_NOT_FOUND': 'Объявление не найдено',
    'LISTING_TITLE_EMPTY': 'Заголовок объявления не может быть пустым',
    'LISTING_DESCRIPTION_EMPTY': 'Описание объявления не может быть пустым',
    'LISTING_INVALID_TYPE': 'Неверный тип объявления',
    'LISTING_INVALID_PRICE': 'Некорректная цена',
    'LISTING_IS_ACTIVE': 'Объявление уже активно',
    'LISTING_IS_REJECTED': 'Объявление отклонено модератором',
    'LISTING_NOT_ACTIVE': 'Объявление сейчас неактивно',
    'LISTING_INVALID_PERFORMER': 'Нельзя откликнуться на это объявление',
    'FILE_TOO_LARGE': 'Суммарный размер фото слишком большой. Загрузите меньше фото за раз или уменьшите их размер',
    'IMAGE_TOO_LARGE': 'Одно из фото слишком большое (максимум 15МБ). Уменьшите размер и попробуйте снова',
    'TOO_MANY_IMAGES': 'Можно загрузить не больше 10 фото за раз',
    'SERVICE_OVERLOADED': 'Сервер сейчас перегружен. Попробуйте ещё раз через минуту',

    // === CATEGORY ===
    'INVALID_CATEGORY': 'Неверная категория',
    'CATEGORY_NOT_FOUND': 'Категория не найдена',
    'CATEGORY_INVALID_LISTING_TYPE': 'Категория не подходит для этого типа объявления',
    'CATEGORY_ALREADY_EXISTS': 'Такая категория уже существует',

    // === USER ===
    'INVALID_USER_ID': 'Неверный ID пользователя',
    'SELF_SUBSCRIPTION': 'Вы не можете подписаться на себя',
    'INVALID_PHONE_NUMBER': 'Некорректный номер телефона',
    'PROFILE_IS_ACTIVATED': 'Ваш профиль уже активирован. Код подтверждения не требуется',

    // === PROFILE ===
    'CHANGE_PASSWORD_CURRENT_INCORRECT': 'Текущий пароль введён неверно',
    'AVATAR_UPLOAD_FAILED': 'Не удалось загрузить аватар. Проверьте формат и размер файла',
    'AVATAR_NOT_FOUND': 'Аватар не установлен',

    // === NOTIFICATION ===
    'NOTIFICATION_NOT_FOUND': 'Уведомление не найдено',
    'TITLE_IS_EMPTY': 'Заголовок уведомления не может быть пустым',
    'DESCRIPTION_IS_EMPTY': 'Описание уведомления не может быть пустым',

    // === MESSENGER ===
    'MESSENGER_NOT_FOUND': 'Мессенджер не найден',
    'MESSENGER_TITLE_EMPTY': 'Название мессенджера не может быть пустым',
    'MESSENGER_CATEGORY_EMPTY': 'Категория мессенджера не может быть пустой',
    'MESSENGER_GROUP_EMPTY': 'Группа мессенджера не может быть пустой',
    'MESSENGER_TOKEN_EMPTY': 'Токен мессенджера не может быть пустым',
    'MESSENGER_LOCATION_EMPTY': 'Расположение мессенджера не может быть пустым',
    'MESSENGER_DESCRIPTION_EMPTY': 'Описание мессенджера не может быть пустым',
    'MESSENGER_INVALID_TYPE': 'Неверный тип мессенджера',

    // === SUPPORT ===
    'TICKET_NOT_FOUND': 'Обращение не найдено',
    'TICKET_TITLE_EMPTY': 'Заголовок обращения не может быть пустым',
    'TICKET_MESSAGE_EMPTY': 'Сообщение не может быть пустым',
    'TICKET_IS_CLOSED': 'Обращение закрыто. Отправка сообщений недоступна',
    'INVALID_CURSOR_PARAM': 'Неверные параметры пагинации',
    'INVALID_TICKET_ID': 'Неверный ID обращения',
    'SEND_FORM_MESSAGE_BAD_GATEWAY': 'Не удалось отправить сообщение. Попробуйте позже',
    'SEND_FORM_INVALID_TYPE': 'Выберите корректный тип обращения',
    'SEND_FORM_EMAIL_EMPTY': 'Укажите email',
    'SEND_FORM_MESSAGE_EMPTY': 'Напишите сообщение',

    // === LOCATION ===
    'LOCATION_NOT_FOUND': 'Расположение не найдено',

    // === REPORT ===
    'REPORT_EXISTS': 'Вы уже подавали жалобу на это объявление',
    'INVALID_REPORT_REASON': 'Укажите причину жалобы',

    // === COMMON ===
    'NOT_FOUND': 'Не найдено',
    'ALREADY_EXISTS': 'Уже существует',
    'INTERNAL_ERROR': 'Внутренняя ошибка сервера',
    'UPLOAD_IMAGES_ERROR': 'Ошибка загрузки изображений',
    'ERROR_UPLOAD_IMAGES': 'Ошибка загрузки изображений',
    'NO_CHANGE': 'Нет изменений',
};

// Ошибки, которые НЕ нужно показывать пользователю как toast
export const SILENT_ERRORS = new Set([
    'INVALID_PARTICIPANT',         // обрабатывается локально в sendFirstMessage
    'RESPONSE_NOT_FOUND',          // нормально: пользователь ещё не откликнулся
    'QUICK_POST_INVALID_STATUS',   // кнопка скрыта — пользователь не должен видеть
    'CANNOT_WITHDRAW',             // кнопка disabled — пользователь не должен видеть
    'REPORT_EXISTS',               // обрабатывается локально в ReportListingModal
    'INVALID_REPORT_REASON',       // обрабатывается локально в ReportListingModal
]);

// Ошибки авторизации — нужно перенаправить на логин
export const AUTH_ERRORS = new Set([
    'UNAUTHORIZED',
    'TOKEN_EXPIRED',
    'INVALID_TOKEN',
]);

// Бан — нужно разлогинить и перенаправить на логин с понятным тостом.
// USER_IS_BANNED оставлен как страховка на случай рассинхрона версий
// фронта/бэка (бэк отдаёт только USER_BANNED, но старый бандл в кэше браузера
// мог наблюдать оба).
export const BAN_ERRORS = new Set([
    'USER_BANNED',
    'USER_IS_BANNED',
]);

// Получить понятное сообщение для кода ошибки
export function getErrorMessage(code, fallback = 'Произошла ошибка') {
    return ERROR_MESSAGES[code] || fallback;
}

// Определить тип ошибки для правильной обработки
export function getErrorType(code) {
    if (AUTH_ERRORS.has(code)) return 'auth';
    if (SILENT_ERRORS.has(code)) return 'silent';
    return 'notification';
}
